import styled from 'styled-components';

export const UserTitle = styled.h2`
  font-size: 32px;
  margin-bottom: 20px;
`;
